export const EMPTY_PACKAGE_ID = null;
export const EMPTY_SERVICE_ID = null;
export const EMPTY_CONFIRMATION_ID = null;
export const EMPTY_PROVIDER_ID = null;
export const None = 'None';
export const STAMPS_USPSFIRSTCLASS_SERVICE_ID = '10';
export const ENDICIA_USPSFIRSTCLASS_SERVICE_ID = '18';
export const STAMPS_FIRSTCLASSINTERNATIONAL_SERVICE_ID = '17';
export const ENDICIA_FIRSTCLASSINTERNATIONAL_SERVICE_ID = '96';
export const NO_BOX_NO_LABEL_DISPLAY_SCHEME = 'NoBoxNoLabel';
